const default_icon = Object.freeze({
    name: 'bell outline',
    color: 'currentColor'
});

const icons = {
    "Treatment Plan": "drugsMedicineInfo",
    "Medical certificate": "doc-stamp",
    "Referral": "eye",
    "Pathology": "patho-microscope",
    "Consultation": "doc-steth",
    "Prescription": "smartphone-cross-hand"
}

const getNotificationIcon = (notification, type) => {
    const result = { ...default_icon };

    if (notification.icon) {
        result.name = notification.icon;
    } else if (icons[type]) {
       result.name = icons[type]
    }

    if (notification.icon_color) {
        result.color = notification.icon_color;
    }

    return result;
};

export default getNotificationIcon; 